import React from "react";

export const ReviewModal = ({
  open,
  onClose,
  sections = [],
  answers = {},
  pages = [],
  goToPage,
}) => {
  if (!open) return null;

  const statForSection = (si) => {
    const items = sections[si]?.items || [];
    let total = 0,
      answered = 0;
    items.forEach((row, qi) => {
      if (row?.item?.kind === "audio_gate") return; // سؤال محسوب نکن
      total += 1;
      const v = answers?.[si]?.[qi];
      const hasValue =
        v != null &&
        (typeof v === "string"
          ? v.trim() !== ""
          : Object.keys(v || {}).length > 0);
      if (hasValue) answered += 1;
    });
    return { total, answered };
  };

  // map کردن هر سوال به pageIdx (برای پرش)
  const pageOf = (si, qi) => {
    const idx = pages.findIndex(
      (pg) => pg.si === si && pg.type === "partOnePerPage" && pg.qi === qi
    );
    return idx >= 0 ? idx : null;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4 p-6 z-10">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold">Review</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="space-y-5 max-h-[60vh] overflow-y-auto">
          {sections.map((s, si) => {
            const { total, answered } = statForSection(si);
            if (!total) return null;
            return (
              <div key={si} className="border rounded-xl p-3">
                <div className="flex items-center justify-between mb-2">
                  <div className="font-semibold">
                    {s?.title?.fa || s?.title?.en || `Section ${si + 1}`}
                  </div>
                  <div className="text-xs text-gray-500">
                    {answered}/{total} {/** answered out of total */}
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  {(s.items || []).map((row, qi) => {
                    if (row?.item?.kind === "audio_gate") return null;
                    const v = answers?.[si]?.[qi];
                    const hasValue =
                      v != null &&
                      (typeof v === "string"
                        ? v.trim() !== ""
                        : Object.keys(v || {}).length > 0);
                    const idx = pageOf(si, qi);
                    return (
                      <button
                        key={qi}
                        onClick={() => {
                          if (idx != null) goToPage(idx);
                          onClose();
                        }}
                        className={`w-8 h-8 rounded-md text-xs font-semibold border
                          ${
                            hasValue
                              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                              : "bg-gray-50 text-gray-600 border-gray-200"
                          }
                        `}
                        title={hasValue ? "Answered" : "Unanswered"}
                      >
                        {qi + 1}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-4 text-[11px] text-gray-500">
          روی شماره‌ی سؤال کلیک کن تا به همان سؤال بروی.
        </div>
      </div>
    </div>
  );
};
